import { createServerApi } from '@/lib/server-api';

import type { ActiveAdResponse, AdPlacement } from '../types';

export const getActiveAdReqSSR = async (placement: AdPlacement): Promise<ActiveAdResponse> => {
  try {
    const serverApi = await createServerApi();
    const response = await serverApi.get<ActiveAdResponse>('/api/v1/ads/active', {
      params: { placement },
    });

    return response.data;
  } catch (error) {
    console.error(`Failed to fetch active ad for placement "${placement}":`, error);
    return { campaign: null };
  }
};
